export default {
  // namespaced: true,
  state: {
    alertModal: null // {title: null, message: null, action: null}
  },
  mutations: {
    SET_ALERT_MODAL (store, data) {
      store.alertModal = data
    }
  },
  getters: {
    getAlertModal: (store, getters) => {
      return store.alertModal
    }
  },
  actions: {
    /*
    setAlertModal
    */
    setAlertModal ({commit, dispatch, getters, state}, data) {
      commit('SET_ALERT_MODAL', data)
      return data
    },
    /*
    closeAlertModal
    */
    closeAlertModal ({commit, dispatch, getters, state}) {
      commit('SET_ALERT_MODAL', null)
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/AlertModal.js